import React from 'react';
import card1 from '../../../assets/images/tarotcards/tarot-card-1.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Card1 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }

    render() {
    return (
        <div>
            <div component="p" style={{
                margin: '25px', color: '#e0515d', marginTop: '100px',
                fontSize: '45px', fontFamily: 'balthazar,serif',
                fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'
            }}>
                <FormattedMessage id="dailylove.title"
                    defaultMessage="Free Daily Love Tarot Reading"
                />
            </div>
            <div style={{ padding: '40px' }}>
                <h2 style={{
                    fontFamily: 'khand,sans-serif',
                    fontSize: '2rem',
                    fontWeight: '100',
                    letterSpacing: '.02em',
                    textTransform: 'uppercase', textAlign: 'center'
                }}><FormattedMessage id="t11"
                    defaultMessage="THE EMPRESS:"
                    />
                </h2>
                <img src={card1} style={{ marginLeft: '9%', float: 'left', padding: '20px' }} />

                <p style={{
                    fontSize: '2rem', color: '#fefefe',
                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%', fontWeight: '400'
                }}>
                    <br></br>
                    <FormattedMessage id="t12"
                        defaultMessage="Have you been trying too hard to make something happen? The Empress reveals that you're looking for The One, but that isn't a good reason to pass up an admirer who's right in front of you. Apply care and gentleness to a pot of romance and see what grows. Aggression and anger have no place in your romantic dealings today."
                    />

                    <br></br><br></br>
                </p>
            </div>
            <div style={{ display: 'flex', paddingBottom: '50px' }}>
                <span style={{ width: '33%' }}>
                </span>
                <span style={{ width: '33%' }}>
                    <Link to="/dailyLove">
                        <button style={{ lineHeight: '2', letterSpacing: '0.02em' }} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                            defaultMessage="PICK ANOTHER CARD"
                        /></strong></button>
                    </Link>
                </span>
                <span style={{ width: '34%' }}>
                </span>
            </div>        
                
        </div>
        )
    }
}

export default Card1;





// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard1.js